import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { defineComponent } from "vue";
import _ from "lodash";


export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    name: null
  },
  setup(__props: any) {

const { name } = __props as { name: string }

const images = {
  "pele-muito-clara": require("../../assets/img/pele-muito-clara.png"),
  "pele-clara": require("../../assets/img/pele-clara.png"),
  "pele-clara-media": require("../../assets/img/pele-clara-media.png"),
  "pele-media": require("../../assets/img/pele-clara-media.png"),
  "pele-escura": require("../../assets/img/pele-escura.png"),
  "pele-media-escura": require("../../assets/img/pele-media-escura.png"),
};

defineComponent({
  name: "Icon",
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: _unref(_).get(images, __props.name),
    class: "image"
  }, null, 8, _hoisted_1))
}
}

})